import React from 'react';

import { Field } from '@atlaskit/form';

import { Select } from '@qality/common-components/src/atoms/Select';

import { SelectFieldWrapper } from './Select.styled';

export const SelectView = ({
  input,
  meta,
  label,
  isDisabled,
  isRequired,
  isClearable,
  options,
  placeholder,
  size,
  onInputChange,
}: any) => {
  return (
    <SelectFieldWrapper hasLabel={!!label}>
      <Field
        data-testid='Field'
        label={label}
        isRequired={isRequired}
        name={input.name}
      >
        {() => (
          <div className='hide-focus-wrapper'>
            <Select
              classNamePrefix='list'
              onChange={input.onChange}
              onInputChange={onInputChange}
              value={input.value}
              options={options}
              validationState={
                meta.touched && !!meta.error ? 'error' : undefined
              }
              isDisabled={isDisabled}
              isClearable={isClearable}
              placeholder={placeholder}
              size={size}
            />
          </div>
        )}
      </Field>
    </SelectFieldWrapper>
  );
};
